'use strict';

(function($) {
  let wbQuickviewAutoplay = null;

  $('body').on('click', '.js-wbquickview-link', e => {
    e.preventDefault();

    const $currentTarget = $(e.currentTarget);
    let product_url = $currentTarget.data('url');
    const variant_id = $currentTarget.attr('variant-id');

    if (product_url.indexOf("?") > 0) {
      product_url = product_url.substring(0, product_url.indexOf("?"));
    }

    $.ajax({
      url: product_url + '?view=wbquickview' + ((typeof variant_id !== 'undefined') ? '&variant=' + variant_id : ''),
      success: function(data) {
        if (!data) return;

        const html = $(data).find('[data-html="content"]').html();

        $.magnificPopup.open({
          preloader: true,
          tLoading: '',
          items: {
            src: '<div id="wbquickview" class="js-wbquickview white-popup">' + html + '</div>',
            type: 'inline'
          },
          closeBtnInside: true,
          callbacks: {
            open: function() {
              if (typeof Shopify.PaymentButton !== 'undefined') {
                Shopify.PaymentButton.init();
              }

              // Voorraadtekst versimpelen
              $('#wbquickview')
                .find('*')
                .filter(function() {
                  return $(this).children().length === 0 && $(this).text().includes('Op voorraad');
                })
                .each(function() {
                  $(this).text('Op voorraad, klaar voor verzending');
                });

              // "Inclusief btw." verwijderen
              $('#wbquickview')
                .find('*')
                .filter(function() {
                  const txt = $(this).text().trim().toLowerCase();
                  return $(this).children().length === 0 && (txt === 'inclusief btw.' || txt === 'inclusief btw');
                })
                .hide();

              // Quickview sluiten na toevoegen aan winkelwagen
              $(document).off('click.wbquickviewAdd').on('click.wbquickviewAdd', '#wbquickview .product-form__submit', function() {
                setTimeout(function() {
                  $.magnificPopup.close();
                }, 1200);
              });

              // Slider autoplay: klik elke 3 sec op volgende afbeelding
              clearInterval(wbQuickviewAutoplay);

              wbQuickviewAutoplay = setInterval(function() {
                const $popup = $('#wbquickview');

                if (!$popup.length) {
                  clearInterval(wbQuickviewAutoplay);
                  return;
                }

                const $next = $popup.find('.slider-button--next:not([disabled])').first();

                if ($next.length) {
                  $next.trigger('click');
                }
              }, 3000);
            },

            close: function() {
              clearInterval(wbQuickviewAutoplay);
              $(document).off('click.wbquickviewAdd');
            }
          }
        });

        if (e.keyCode == 27) {
          $.magnificPopup.close();
        }
      }
    });
  });
})(jQuery);